// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"57d45d5b","341":"cff52d67","463":"40f4f504","756":"55ee6dc1","899":"e6d5bd5b","955":"cf3e18ac"}[chunkId] + ".chunk.css";
};